export default {
  allReadjustmentIndices: [],
  readjustmentIndice: {},
}
